import React from 'react';
import { PageHeader, Tabs } from 'antd';

import CodeHighlight from 'code-highlight';

// import all the styles
import "code-highlight/lib/style.css";
import "highlight.js/styles/github-gist.css";

const { TabPane } = Tabs;
const routes = [
  {
    path: '/',
    breadcrumbName: 'Displays',
  },
  {
    path: 'Tables',
    breadcrumbName: 'Tables',
  },
];

const Positions = () => {
  return (
    <>

      <PageHeader title="Tables" breadcrumb={{ routes }} subTitle="Tables" style={{ padding: 10 }} />

      <div className="MF_area">
        <h3>· Table-basic</h3>
        <table className="table">
          <tbody>
          <tr>
            <th>th1</th>
            <td>td1</td>
          </tr>
          <tr>
            <th>th2</th>
            <td>td2</td>
          </tr>
          </tbody>
        </table>

        <br /><br />
        <h3>· Table-blue</h3>
        <table className="table blue">
          <tbody>
            <tr>
              <th>th1</th>
              <td>td1</td>
            </tr>
            <tr>
              <th>th2</th>
              <td>td2</td>
            </tr>
          </tbody>
        </table>
        <br /><br />
        <h3>· Table-border</h3>
        <table className="table table_border">
          <tbody>
            <tr>
              <th>th1</th>
              <th>th2</th>
              <th>th3</th>
              <th>th4</th>
            </tr>
            <tr>
              <td>td1</td>
              <td>td2</td>
              <td>td3</td>
              <td>td4</td>
            </tr>
          </tbody>
        </table>
        <br /><br />
        <h3>· Table-green-border</h3>
        <table className="table table_border green">
          <tbody>
            <tr>
              <th>th1</th>
              <th>th2</th>
              <th>th3</th>
              <th>th4</th>
            </tr>
            <tr>
              <td>td1</td>
              <td>td2</td>
              <td>td3</td>
              <td>td4</td>
            </tr>
          </tbody>
        </table>
      </div>
      <div className="codeArea">
        <Tabs defaultActiveKey="1">
          <TabPane tab="HTML" key="1">
            <CodeHighlight language="HTML">
              {`<h3>· Table-basic</h3>
<table class="table">
  <tr>
    <th>th1</th>
    <td>td1</td>
  </tr>
  <tr>
    <th>th2</th>
    <td>td2</td>
  </tr>
</table>

<br /><br />
<h3>· Table-blue</h3>
<table class="table blue">
  <tr>
    <th>th1</th>
    <td>td1</td>
  </tr>
  <tr>
    <th>th2</th>
    <td>td2</td>
  </tr>
</table>
<br /><br />
<h3>· Table-border</h3>
<table class="table table_border">
  <tr>
    <th>th1</th>
    <th>th2</th>
    <th>th3</th>
    <th>th4</th>
  </tr>
  <tr>
    <td>td1</td>
    <td>td2</td>
    <td>td3</td>
    <td>td4</td>
  </tr>
</table>
<br /><br />
<h3>· Table-green-border</h3>
<table class="table table_border green">
  <tr>
    <th>th1</th>
    <th>th2</th>
    <th>th3</th>
    <th>th4</th>
  </tr>
  <tr>
    <td>td1</td>
    <td>td2</td>
    <td>td3</td>
    <td>td4</td>
  </tr>
</table>`}
            </CodeHighlight>
          </TabPane>
        </Tabs>
      </div>

    </>
  );
}

export default Positions;
